var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":_vm.counterId}},[_vm._v(_vm._s(_vm.init))])
}
var staticRenderFns = []

export { render, staticRenderFns }